import filter from 'lodash/filter';
import includes from 'lodash/includes';

function isLabelContainsText(label, text) {
	return includes(label.toLowerCase(), text.toLowerCase());
}

function createLookupInEnum(options) {
	return async (text) => ({
		options: !text ? options : filter(options, item => isLabelContainsText(item.label, text))
	});
}

export default createLookupInEnum;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/create-lookup-in-enum.js